import React from 'react';
import { getUniversalSearchFormLabel } from '../../common/helpers/get-usx-labels';
import { useEnabledFeatures } from '../../common/hooks/enabled-features';
import { WorkspacePanelButton } from '../../panels/workspace-panel-button';

export function DexFormsButton(): React.ReactElement {
    const { dexNextEnabled } = useEnabledFeatures();

    return (
        <WorkspacePanelButton
            tooltipText={`${getUniversalSearchFormLabel(dexNextEnabled)}`}
            workspacePanelType="DATA_EXCHANGE_FORMS"
            aria-label="open dex forms"
            icon="DataExchangeInquiries"
        />
    );
}
